import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { SetCurrentPage, ProprieteState } from '../../propriete.state';
import { SetCurrentCodePage } from '../../../shared/navigation.state';
import { ProprieteModele } from '../../modeles/proprieteModel';

@Component({
  selector: 'app-page-introduction',
  templateUrl: './page-introduction.component.html',
  styleUrls: ['./page-introduction.component.scss'],
  standalone: false
})
export class PageIntroductionComponent implements OnInit {
  hasExistingV2Properties: boolean;

  @Select(ProprieteState.proprietes)
  proprietes$: Observable<ProprieteModele[]>;

  constructor(private readonly router: Router, private readonly _store: Store) {
    this.hasExistingV2Properties = false;
  }

  ngOnInit(): void {
    this._store.dispatch(new SetCurrentPage('liste'));
    this._store.dispatch(new SetCurrentCodePage('liste'));
    this.proprietes$.subscribe(data => {
      if (data.length > 0) {
        for (const propriete of data) {
          if (propriete.type) {
            this.hasExistingV2Properties = true;
            break;
          }
        }
      }
    });
  }

  navigateTo(target: string): void {
    this.router.navigate([target]);
  }

  get textContent() {
    return this.hasExistingV2Properties ? 'introduction.paragraphe-fiche-existante' : 'introduction.paragraphe';
  }
}
